<header [preLogin]="false"></header>
<div class="post-login-1">
    <div class="post-login-1-col-1 h-100">
        <app-left-panel-prelogin activeTab="2"></app-left-panel-prelogin>


    </div>
    <div class="post-login-1-col-2 h-100 p-mobile-15">
        <grid-row class="justify-content-center pt-160 pt-mobile-0 h-100vh-101">
            <grid-col col="4" mobile="12">
                <div class="font-size-24px font-400 color-base-700 line-h-32 letter-spacing-1">
                    {{ "PleaseSelectProduct" | translate }}</div>
                <div class="mt-50">
                    <div class="bg-base-100 p-16 box-shadow br-16 mt-16 mb-16 link" (click)="quickpay('C')">
                        <grid-row class="col-space-min align-item-center">
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-credit-card-green v-align-middle text-align-left" width="29"
                                    height="29"></ng-icon>
                            </grid-col>
                            <grid-col col="8" mobile="auto">
                                <span class="font-size-14px font-600 color-base-700 line-h-18">
                                    {{ "CreditCard" | translate }}</span>
                            </grid-col>
                        </grid-row>
                    </div>
                </div>
                <div class="mt-30">
                    <div class="bg-base-100 p-16 box-shadow br-16 mt-16 mb-16 link" (click)="quickpay('L')">
                        <grid-row class="col-space-min align-item-center">
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-laon-green v-align-middle text-align-left" width="29"
                                    height="29"></ng-icon>
                            </grid-col>
                            <grid-col col="8" mobile="auto">
                                <span class="font-size-14px font-600 color-base-700 line-h-18">
                                    {{ "Loan" | translate }}</span>
                            </grid-col>
                        </grid-row>
                    </div>
                </div>
            </grid-col>
        </grid-row>
    </div>
</div>